<template>
  <CustomUpdateDialog
    dialogTitle="ویرایش تخفیف حجمی"
    dialogId="update-volume-discount-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="updateVolumeDiscount"
  >
    <BCol cols="12">
      <DiscountTypePicker
        v-model="volumeDiscountPayload.discountType"
      ></DiscountTypePicker>
    </BCol>
    <BCol cols="12">
      <VolumeDiscountTypePicker
        v-model="volumeDiscountPayload.volumeDiscountType"
      ></VolumeDiscountTypePicker>
    </BCol>
    <BCol cols="12">
      <CustomAppendText
        :isText="true"
        customRules="required|min:1"
        inputId="discountValue"
        :inputLabel="handleDiscountValueInputLabel"
        :inputPlaceholder="handleDiscountValueInputPlaceholder"
        v-model="volumeDiscountPayload.discountValue"
      >
        <template #append>
          {{ handleDiscountValueInputAppend }}
        </template>
      </CustomAppendText>
    </BCol>
    <BCol cols="12">
      <TextInput
        customRules="required|min:1"
        inputId="minOrderQuantity"
        :inputLabel="handleMinOrderQuantityInputLabel"
        inputPlaceholder="5"
        v-model="volumeDiscountPayload.minOrderQuantity"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <CustomAppendText
        :isText="true"
        customRules="required|min:1"
        inputId="minTotalPrice"
        inputLabel="حداقل مبلغ سفارش"
        inputPlaceholder="500000"
        v-model="volumeDiscountPayload.minTotalPrice"
      >
        <template #append> تومان </template>
      </CustomAppendText>
    </BCol>
  </CustomUpdateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  props: {
    defaultVolumeDiscount: {
      type: Object,
    },
  },
  watch: {
    defaultVolumeDiscount: {
      handler(val) {
        if (val) {
          this.volumeDiscountPayload = val;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      volumeDiscountPayload: {
        volumeDiscountType: 1,
        discountType: 1,
        discountValue: null,
        minOrderQuantity: null,
        minTotalPrice: null,
      },
      volumeDiscountPersianTypes: {
        1: "درس",
        2: "دوره",
      },
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async updateVolumeDiscount() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let updateAVolumeDiscount = new UpdateAVolumeDiscount(_this);
        updateAVolumeDiscount.setRequestParamDataObj(
          _this.volumeDiscountPayload
        );
        await updateAVolumeDiscount.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "تخفیف حجمی با موفقیت ویرایش شد.",
              },
            });
            _this.volumeDiscountPayload = {
              volumeDiscountType: 1,
              discountType: 1,
              discountValue: null,
              minOrderQuantity: null,
              minTotalPrice: null,
            };
            this.$bvModal.hide("update-volume-discount-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  computed: {
    handleDiscountValueInputPlaceholder() {
      return this.volumeDiscountPayload.discountType == 1 ? "10000" : "5";
    },
    handleDiscountValueInputAppend() {
      return this.volumeDiscountPayload.discountType == 1 ? "تومان" : "%";
    },
    handleDiscountValueInputLabel() {
      return `مقدار تخفیف (${
        this.volumeDiscountPayload.discountType == 1 ? "مبلغ" : "درصد"
      })`;
    },
    handleMinOrderQuantityInputLabel() {
      return `حداقل تعداد ${
        this.volumeDiscountPersianTypes[
          this.volumeDiscountPayload.volumeDiscountType
        ]
      } در سفارش`;
    },
  },
  components: {
    CustomUpdateDialog,
    DiscountTypePicker,
    VolumeDiscountTypePicker,
    CustomAppendText,
    BCol,
    TextInput,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import DiscountTypePicker from "@/views/components/Discount/DiscountTypePicker.vue";
import VolumeDiscountTypePicker from "@/views/components/VolumeDiscounts/VolumeDiscountTypePicker.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { UpdateAVolumeDiscount } from "@/libs/Api/VolumeDiscounts";
</script>
